export class SlideShowHelper {
  static getVisibleSlides(index: number, currentSlide: number, isGridView: boolean) {
    if (isGridView) {
      return index >= currentSlide * 9 && index <= currentSlide * 9 + 8;
    }
    return index === currentSlide;
  }

  static updateCurrentSlide(slideIndex: number, direction: number, currentSlides: number) {
    return (slideIndex + direction + currentSlides) % currentSlides;
  }
}
